import { createContext } from "react";

/**
 * SubScopeValue — the subset of scope fields that SubScopeProvider can override.
 *
 * Only read-only identity fields are overridable. Mutation methods
 * (changeScope, changeActiveWorkspace, etc.) always come from the main ScopeContext
 * so that global state is never silently shadowed.
 */
export interface SubScopeValue {
    workspaceId?: string | null;
}

/**
 * Context is null when no SubScopeProvider is present in the tree,
 * which is the common case — useScope() falls back to main scope transparently.
 */
export const SubScopeContext = createContext<SubScopeValue | null>(null);
